import $ from "jquery";
import "jquery-mask-plugin";

export default class Mask {
    static aplicarMascara(input: HTMLInputElement, tipo: string) {
        const $input = $(input);

        switch (tipo) {
            case "cpf":
                $input.mask("000.000.000-00", { reverse: true });
                break;
            case "cep":
                $input.mask("00000-000");
                break;
            case "celular":
                $input.mask("(00) 00000-0000");
                break;
            case "telefone":
                $input.mask("(00) 0000-0000");
                break;
            default:
                break;
        }
    }

    static aplicarMascarasAutomaticamente(context: JQuery | HTMLElement | Document | string = document) {
        const elementos = $(context as any).find<HTMLInputElement>("[data-mask]");
        elementos.each((_index, el) => {
            const tipo = el.getAttribute("data-mask");
            if (tipo) {
                Mask.aplicarMascara(el, tipo);
            }
        });
    }

    static formatarCPF(cpf: string): string {
        if (!cpf) return "";
        const cpfLimpo = cpf.replace(/\D/g, "");
        if (cpfLimpo.length !== 11) return cpf;
        return cpfLimpo.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
    }

    static formatarCEP(cep: string): string {
        if (!cep) return "";
        const cepLimpo = cep.replace(/\D/g, "");
        if (cepLimpo.length !== 8) return cep;
        return cepLimpo.replace(/^(\d{5})(\d{3})$/, "$1-$2");
    }

    static formatarTelefone(telefone: string): string {
        if (!telefone) return "";
        const telefoneLimpo = telefone.replace(/\D/g, "");
        if (telefoneLimpo.length !== 10) return telefone;
        return telefoneLimpo.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3");
    }

    static formatarCelular(celular: string): string {
        if (!celular) return "";
        const celularLimpo = celular.replace(/\D/g, "");
        if (celularLimpo.length !== 11) return celular;
        return celularLimpo.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
    }

    static adicionarDataMaskAosCampos(context: JQuery | HTMLElement | Document | string = document) {
        const find = (selector: string) => $(context as any).find(selector);

        find('input[name$="CPF"]').attr("data-mask", "cpf");
        find('input[name$="Telefone"]').attr("data-mask", "telefone");
        find('input[name$="Celular"]').attr("data-mask", "celular");
        find('input[name$="CEP"]').attr("data-mask", "cep");
    }

    static prevenirEspacosBrancos(seletores: string | string[]) {
        const seletoresArray = Array.isArray(seletores) ? seletores : [seletores];
        const seletorFinal = seletoresArray.join(', ');
        
        $(seletorFinal).on('paste', function(e) {
            const clipboardData = (e.originalEvent || e as any).clipboardData;
            if (!clipboardData) return;
            
            const pasted = clipboardData.getData('text');
            if (/\s/.test(pasted)) {
                e.preventDefault();
                const textoSemEspacos = pasted.replace(/\s/g, '');
                const input = e.target as HTMLInputElement;
                const start = input.selectionStart || 0;
                const end = input.selectionEnd || 0;
                const valorAtual = input.value;
                
                input.value = valorAtual.substring(0, start) + textoSemEspacos + valorAtual.substring(end);
                input.setSelectionRange(start + textoSemEspacos.length, start + textoSemEspacos.length);
            }
        });
    }
}
